import React from "react";
import "../../../assets/css/speakers.css";

import andrelago from "../../images/speakers/andrelago.jpg";
import goncalosilva from "../../images/speakers/goncalosilva.jpg";
import joaooliveira from "../../images/speakers/joaooliveira.jpg";
import tiagocarcao from "../../images/speakers/tiagocarcao.png";

import Button from "../../buttons/button";
import Speaker from "../../utils/speaker";
import Container from "../../container/container";

const speakers = [
  {
    name: "André Lago",
    job: "Software Engineer and Tech Lead",
    desc: "Google",
    img: andrelago,
    speakerID: "andrelago",
    day: 3,
  },
  {
    name: "Gonçalo Silva",
    job: "Chief Technical Officer",
    desc: "Doist",
    img: goncalosilva,
    speakerID: "goncalosilva",
    day: 2,
  },
  {
    name: "João Oliveira",
    job: "Chief Technical Officer",
    desc: "TonicApp SA",
    img: joaooliveira,
    speakerID: "joaooliveira",
    day: 0,
  },
  {
    name: "Tiago Carção",
    job: "Software Engineer and Tech Lead",
    desc: "Glovo",
    img: tiagocarcao,
    speakerID: "tiagocarcao",
    day: 1,
  },
];

function SpeakerList() {
  const listItems = speakers.map((s, i) => (
    <Speaker
      key={i}
      speaker={s.img}
      alt={s.name}
      name={s.name}
      job={s.job}
      desc={s.desc}
      speakerID={s.speakerID}
      day={s.day}
    />
  ));

  return <div className="images">{listItems}</div>;
}

function Speakers(props) {
  return (
    <div className="speakers" style={{ ...props.style }}>
      <Container>
        <div className="container">
          <div className="desc">
            <h3 className="speaker-title">
              Here’s a selection of this year’s speakers
            </h3>
            <a href="/speakers">
              <Button
                background="#102333"
                width="169px"
                padd="18px"
                style={{ marginTop: "15px" }}
              >
                Explore
              </Button>
            </a>
          </div>
          <SpeakerList />
        </div>
      </Container>
    </div>
  );
}
export default Speakers;
